export var getAggregateCardProps = function (state, event, dict) {
    return {
        event: event,
        sportId: event.sportId,
        handler: state.openGameTranspiler.bind(state, event),
        dict: dict,
    };
};
//# sourceMappingURL=getAggregateCardProps.js.map